import { CLIENT_URI } from '@/constants/urls';
import { locales } from '@/i18n';
import { allClearHtml } from '@/utils/html';
import { getTranslations } from 'next-intl/server';

export const titleConcat = (text, titleAppendix = ' - Guestit') => {
  const allText = allClearHtml(text);
  return allText + titleAppendix;
};

export const descLimit = (text) => {
  const allText = allClearHtml(text);
  if (allText.length <= 155) return allText;

  let sentences = allText.match(/[^.!?]+[.!?]/g) || [];
  let combinedSentences = sentences.reduce((acc, sentence) => {
    let newAcc = acc + sentence;
    return newAcc.length > 100 && newAcc.length <= 155 ? newAcc : acc;
  }, '');

  return combinedSentences || allText.slice(0, 155);
};

export const getPageUrl = (locale, pathname) =>
  `${CLIENT_URI}${locale !== locales.sv ? `/${locale}` : ''}${pathname}`;

export const getMetadata = async ({
  locale,
  title,
  titleIsGeneral = true,
  description,
  disableCanonical = false,
  canonical,
  pathname,
  robots,
  prevLink,
  nextLink,
  languages,
}) => {
  const pageUrl = getPageUrl(locale, pathname);

  const t = await getTranslations({
    locale,
  });

  const metadata = {
    title: `${t('main.meta.title')} - Guestit`,
    description: descLimit(t('main.meta.description')),
    openGraph: {
      title: `${t('main.meta.title')} - Guestit`,
      description: descLimit(t('main.meta.description')),
      url: pageUrl,
      type: 'website',
      images: [`${CLIENT_URI}/og.jpg`],
    },
    twitter: {
      title: `${t('main.meta.title')} - Guestit`,
      description: descLimit(t('main.meta.description')),
      card: 'summary',
      images: [`${CLIENT_URI}/og.jpg`],
    },
    alternates: {
      canonical: pageUrl,
      languages: {
        en: `${CLIENT_URI}/en${pathname}`,
        sv: `${CLIENT_URI}${pathname}`,
      },
    },
    other: { Guestit: 'Guestit' },
    icons: {
      icon: [
        { url: '/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
        { url: '/favicon-16x16.png', sizes: '16x16', type: 'image/png' },
      ],
      apple: { url: '/apple-touch-icon.png', sizes: '180x180' },
      other: [
        { rel: 'mask-icon', url: '/safari-pinned-tab.svg', color: '#5bbad5' },
      ],
    },
    manifest: '/site.webmanifest',
  };

  if (title) {
    metadata.title = title;

    if (titleIsGeneral) {
      metadata.openGraph.title = title;
      metadata.twitter.title = title;
      metadata.other.title = title;
    }
  }

  if (description) {
    metadata.description = description;
    metadata.openGraph.description = description;
    metadata.twitter.description = description;
  }

  if (disableCanonical) {
    metadata.alternates.canonical = null;

    if (canonical) {
      metadata.alternates.canonical = canonical;
    }
  }

  if (robots) {
    metadata.robots = robots;
  }

  if (prevLink) {
    metadata.icons.other.push(prevLink);
  }

  if (nextLink) {
    metadata.icons.other.push(nextLink);
  }

  if (languages) {
    metadata.alternates.languages = languages;
  }

  return metadata;
};
